import React from 'react';
import { withRouter } from 'react-router';
import Login from './Login';

const ForgotPassword = withRouter(({ history }) => <Login mode="forgotPassword" />);

export default ForgotPassword;
